<div class="d-flex align-items-center">
  <div class="profile-progress-wrapper">
    <svg class="profile-progress-circle" width="42" height="42">
      <!-- Background ring (grey, same radius as progress) -->
      <circle class="profile-progress-bg" cx="30" cy="30" r="24" stroke="#e0e0e0" stroke-width="4" fill="none" />
      <!-- Progress ring (green, as arc path) -->
      <path [attr.d]="
          getProfileProgressArc(
            profilePercentage?.profile_percentage?.profile_percentage || 0,
            30,
            30,
            24
          )
        " stroke="#4caf50" stroke-width="4" fill="none" />
    </svg>
    <img alt="" class="profile_teacher_sm img-complete-match profile-progress-img" [src]="
        profilePercentage?.profile_image &&
        profilePercentage?.profile_image.trim() !== ''
          ? profilePercentage?.profile_image
          : '../../../../assets/images/consumer/profile_monk.png'
      " />
  </div>
  <div class="ml-10">
    <h5 id="profileName" class="text-regular-bold fs-18 align-self-center mb-0 mt-3">
      {{ profilePercentage?.full_name }}
    </h5>
    @if(profilePercentage?.profile_percentage.profile_percentage == 0){
    <p  id="profilePercent" class="text-regular-medium fs-12 clr-red mt-5">
      {{ profilePercentage?.profile_percentage.profile_percentage }}% Profile
      Completed
    </p>
    }@else {
    <p id="profilePercent" class="text-regular-medium fs-12 clr-green mt-5">
      {{ profilePercentage?.profile_percentage.profile_percentage }}% Profile
      Completed
    </p>
    }
  </div>
</div>
<div class="d-flex align-items-center mt-5">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" fill="currentColor" class="bi bi-lightbulb"
    viewBox="0 0 16 20">
    <path
      d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a2 2 0 0 0-.453-.618A5.98 5.98 0 0 1 2 6m6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1" />
  </svg>
  <p id="profileHint" class="txt-regular ml-5">
    Profiles that are 100% complete are more likely to get booked
  </p>
</div>
<div class="mt-10">
  <a appFocus class="user-title c-p clr-cc-vilot" (click)="goToProfile()"  aria-describedby="profileName profilePercent profileHint">Complete profile
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right"
      viewBox="0 0 16 17" stroke="currentColor" stroke-width="1">
      <path fill-rule="evenodd"
        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
    </svg>
  </a>
</div>